// extracted by mini-css-extract-plugin
export default {"container":"carrito_container__l8An9","containerMain":"carrito_containerMain__igypr"};